import { TextField, InputAdornment, CircularProgress } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

interface NotificationSearchFieldProps {
  value: string;
  isSearching: boolean;
  onChange: (query: string) => void;
}

export function NotificationSearchField({
  value,
  isSearching,
  onChange,
}: NotificationSearchFieldProps) {
  return (
    <TextField
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Sök efter innehåll..."
      fullWidth
      size="medium"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" />
          </InputAdornment>
        ),
        endAdornment: isSearching ? (
          <InputAdornment position="end">
            <CircularProgress size={24} />
          </InputAdornment>
        ) : null,
      }}
      sx={{ mb: 2 }}
    />
  );
}
